import {
  defaultErrorComponentMap,
  ErrorMap,
} from "@wiesinghilker/extension-lib-frontend";

export const errorMap: ErrorMap = {
  ...defaultErrorComponentMap,
};
